import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  Flex,
  MODAL_SIZE_MD,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Spinner,
} from 'mailup-web-components'

import {
  modalCopyCancelCallback,
  modalCopyConfirmCallback,
} from 'Pages/UnsubscriptionCampaignsList/recoil/callbacks/modals'
import { modalCopyState } from 'Pages/UnsubscriptionCampaignsList/recoil/state/modals'

const ModalCopy: FC = () => {
  const intl = useIntl()

  const { fetching, show } = useRecoilValue(modalCopyState)

  const handleCancel = useRecoilCallback(modalCopyCancelCallback, [])
  const handleConfirm = useRecoilCallback(modalCopyConfirmCallback, [])

  return (
    <Modal
      data-mu-test="modal-copy-confirm"
      show={show}
      showClose
      onClose={handleCancel}
      closeOnOverlayClick={false}
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ModalConfirmCopy.Title',
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: 'Load.TriggersDetail.WarningCreateCopy',
        })}
      </ModalBody>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={handleCancel}
          disabled={fetching}
          data-mu-test="button-cancel"
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleConfirm}
          data-mu-test="button-confirm"
        >
          <Flex alignItems="center" gap="4px">
            {intl.formatMessage({ id: 'Load.MailupCommon.Continue' })}
            {fetching && <Spinner />}
          </Flex>
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalCopy
